import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _invoke from 'lodash/invoke';
import { withLogger } from 'modules/shell/hoc/withLogger';
import { addNotification } from 'modules/shell/actions';

class ErrorBoundary extends Component {
  constructor() {
    super();

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  logError = (error, info) => {
    _invoke(this.props, 'logger.error', error);
    /* eslint-disable-next-line no-console */
    console.info(
      `%c ${error.message}`,
      `
      background: #333;
      color: #bada55;
      padding: 5px 10px`,
      info,
      '\n',
    );
  };

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    this.logError(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children, addNotification } = this.props;

    if (hasError) {
      addNotification({
        id: `error-${Date.now()}`,
        message: 'Oops! Something went wrong!',
        description: "We'll try to fix it as soon as possible",
        type: 'info',
      });

      return null;
    }

    return children;
  }
}

export { ErrorBoundary };

export default compose(connect(null, { addNotification }), withLogger())(ErrorBoundary);
